import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {select, Store} from '@ngrx/store';
import {EnviromentSelector} from '../store/selectors/fr-selectors';
import {UpdateFRConfiguration} from '../store/actions/fr-actions';
import { IAppState } from 'app/IAppState';

@Component({
  selector: 'biz-fr-config-detail',
  templateUrl: './fr-config-detail.component.html',
  styleUrls: ['./fr-config-detail.component.scss']
})
export class FrConfigDetailComponent implements OnInit {

  @Input() frConfig: IFormsRecognizer;
  @Output() cancelAction: EventEmitter<any> = new EventEmitter<any>()
  environment;
  environment$: any;
  environmentSub: any;

  constructor(private store: Store<IAppState>) {
    this.environment$ = this.store.pipe(select(EnviromentSelector));
    this.environmentSub = this.environment$.subscribe((env)=>{
      this.environment = env;
    })
  }

  ngOnInit() {
  }

  save(){
    this.store.dispatch(new UpdateFRConfiguration(this.frConfig, this.frConfig.id));
  }
}
